var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.94792 1.0625C1.45891 1.0625 1.0625 1.45891 1.0625 1.94792V13.6354C1.0625 14.1244 1.45891 14.5208 1.94792 14.5208H7.61458C8.10359 14.5208 8.5 14.1244 8.5 13.6354V1.94792C8.5 1.45891 8.10359 1.0625 7.61458 1.0625H1.94792Z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61458 0C8.69039 0 9.5625 0.872112 9.5625 1.94792V13.6354C9.5625 14.7112 8.69039 15.5833 7.61458 15.5833H1.94792C0.872112 15.5833 0 14.7112 0 13.6354V1.94792C0 0.872112 0.872112 0 1.94792 0H7.61458ZM7.61458 1.0625L6.906 1.062L6.90625 1.58792C6.90625 1.78674 6.74507 1.94792 6.54625 1.94792H3.01625C2.81743 1.94792 2.65625 1.78674 2.65625 1.58792L2.656 1.062L1.94792 1.0625C1.45891 1.0625 1.0625 1.45891 1.0625 1.94792V13.6354C1.0625 14.1244 1.45891 14.5208 1.94792 14.5208H7.61458C8.10359 14.5208 8.5 14.1244 8.5 13.6354V1.94792C8.5 1.45891 8.10359 1.0625 7.61458 1.0625Z",
    fill: "#F8F9FA"
  })));
};
export default SvgPhone;